const DEFAULT_PAGE = 'home';

export const VERSIONS = {
  TEACHER: 'teacher',
  STUDENT: 'student'
};

export default DEFAULT_PAGE;
